import type {ReactAction} from '@netx/core/bootstrap';
import {faCheck} from '@netx/core-icons';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';

export const searchSavedActionAddToCurrentCartIcon = faCheck;

/**
 * Add all assets to current cart
 * @param params
 * @returns Action
 */
export const searchSavedActionAddToCurrentCart = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-add-to-current-cart',
	cb: () =>
		dispatcher.trigger('search:saved:add:to:current:cart', savedSearch?.id),
	enableTest: () => savedSearch != null,
	icon: searchSavedActionAddToCurrentCartIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.ADD_TO_CURRENT_CART;
	},
	...params,
});

export default searchSavedActionAddToCurrentCart;
